import { SelectOption } from 'components/inputs/BaseSelect';

export interface DetailedDisciplineByKey {
  [key: string]: { key: string; discipline: string; description: string };
}

export const disciplineByKey: DetailedDisciplineByKey = {
  A: { key: 'A', discipline: 'Architectural', description: 'Architectural' },
  AD: {
    key: 'AD',
    discipline: 'Architectural',
    description: 'Architectural Demolition',
  },
  AE: {
    key: 'AE',
    discipline: 'Architectural',
    description: 'Architectural Elements',
  },
  AF: {
    key: 'AF',
    discipline: 'Architectural',
    description: 'Architectural Finishes',
  },
  AG: {
    key: 'AG',
    discipline: 'Architectural',
    description: 'Architectural Graphics',
  },
  AI: {
    key: 'AI',
    discipline: 'Architectural',
    description: 'Architectural Interiors',
  },
  AS: {
    key: 'AS',
    discipline: 'Architectural',
    description: 'Architectural Site',
  },
  B: { key: 'B', discipline: 'Geotechnical', description: 'Geotechnical' },
  C: { key: 'C', discipline: 'Civil', description: 'Civil' },
  CD: { key: 'CD', discipline: 'Civil', description: 'Civil Demolition' },
  CG: { key: 'CG', discipline: 'Civil', description: 'Civil Grading' },
  CI: { key: 'CI', discipline: 'Civil', description: 'Civil Improvements' },
  CN: { key: 'CN', discipline: 'Civil', description: 'Civil Nodes' },
  CP: { key: 'CP', discipline: 'Civil', description: 'Civil Paving' },
  CS: { key: 'CS', discipline: 'Civil', description: 'Civil Site' },
  CT: { key: 'CT', discipline: 'Civil', description: 'Civil Transportation' },
  CU: { key: 'CU', discipline: 'Civil', description: 'Civil Utilities' },
  D: { key: 'D', discipline: 'Process', description: 'Process' },
  DA: { key: 'DA', discipline: 'Process', description: 'Process Airs' },
  DC: { key: 'DC', discipline: 'Process', description: 'Process Chemicals' },
  DD: { key: 'DD', discipline: 'Process', description: 'Process Demolition' },
  DE: { key: 'DE', discipline: 'Process', description: 'Process Electrical' },
  DG: { key: 'DG', discipline: 'Process', description: 'Process Gases' },
  DI: {
    key: 'DI',
    discipline: 'Process',
    description: 'Process Instrumentation',
  },
  DL: { key: 'DL', discipline: 'Process', description: 'Process Liquids' },
  DM: { key: 'DM', discipline: 'Process', description: 'Process HPM Gases' },
  DO: { key: 'DO', discipline: 'Process', description: 'Process Oil' },
  DP: { key: 'DP', discipline: 'Process', description: 'Process Piping' },
  DQ: { key: 'DQ', discipline: 'Process', description: 'Process Equipment' },
  DR: {
    key: 'DR',
    discipline: 'Process',
    description: 'Process Drains and Reclaims',
  },
  DS: { key: 'DS', discipline: 'Process', description: 'Process Site' },
  DV: { key: 'DV', discipline: 'Process', description: 'Process Vacuum' },
  DW: { key: 'DW', discipline: 'Process', description: 'Process Waters' },
  DX: { key: 'DX', discipline: 'Process', description: 'Process Exhaust' },
  DY: { key: 'DY', discipline: 'Process', description: 'Process Slurry' },
  E: { key: 'E', discipline: 'Electrical', description: 'Electrical' },
  ED: {
    key: 'ED',
    discipline: 'Electrical',
    description: 'Electrical Demolition',
  },
  EI: {
    key: 'EI',
    discipline: 'Electrical',
    description: 'Electrical Instrumentation',
  },
  EL: {
    key: 'EL',
    discipline: 'Electrical',
    description: 'Electrical Lighting',
  },
  EP: { key: 'EP', discipline: 'Electrical', description: 'Electrical Power' },
  ES: { key: 'ES', discipline: 'Electrical', description: 'Electrical Site' },
  ET: {
    key: 'ET',
    discipline: 'Electrical',
    description: 'Electrical Telecommunications',
  },
  EY: {
    key: 'EY',
    discipline: 'Electrical',
    description: 'Electrical Auxiliary Systems',
  },
  F: {
    key: 'F',
    discipline: 'Fire Protection',
    description: 'Fire Protection',
  },
  FA: {
    key: 'FA',
    discipline: 'Fire Protection',
    description: 'Fire Protection Detection and Alarm',
  },
  FX: {
    key: 'FX',
    discipline: 'Fire Protection',
    description: 'Fire Protection Suppression',
  },
  G: { key: 'G', discipline: 'General', description: 'General' },
  GC: { key: 'GC', discipline: 'General', description: 'General Contract' },
  GI: { key: 'GI', discipline: 'General', description: 'General Information' },
  GR: { key: 'GR', discipline: 'General', description: 'General Resource' },
  H: {
    key: 'H',
    discipline: 'Hazardous Materials',
    description: 'Hazardous Materials',
  },
  HA: {
    key: 'HA',
    discipline: 'Hazardous Materials',
    description: 'Hazardous Materials Asbestos',
  },
  HC: {
    key: 'HC',
    discipline: 'Hazardous Materials',
    description: 'Hazardous Materials Chemicals',
  },
  HL: {
    key: 'HL',
    discipline: 'Hazardous Materials',
    description: 'Hazardous Materials Lead',
  },
  HP: {
    key: 'HP',
    discipline: 'Hazardous Materials',
    description: 'Hazardous Materials PCB',
  },
  HR: {
    key: 'HR',
    discipline: 'Hazardous Materials',
    description: 'Hazardous Materials Refrigerants',
  },
  I: { key: 'I', discipline: 'Interiors', description: 'Interiors' },
  ID: {
    key: 'ID',
    discipline: 'Interiors',
    description: 'Interior Demolition',
  },
  IF: {
    key: 'IF',
    discipline: 'Interiors',
    description: 'Interior Furnishings',
  },
  IG: { key: 'IG', discipline: 'Interiors', description: 'Interior Graphics' },
  IN: { key: 'IN', discipline: 'Interiors', description: 'Interior Design' },
  L: { key: 'L', discipline: 'Landscape', description: 'Landscape' },
  LD: {
    key: 'LD',
    discipline: 'Landscape',
    description: 'Landscape Demolition',
  },
  LG: { key: 'LG', discipline: 'Landscape', description: 'Landscape Grading' },
  LI: {
    key: 'LI',
    discipline: 'Landscape',
    description: 'Landscape Irrigation',
  },
  LL: { key: 'LL', discipline: 'Landscape', description: 'Landscape Lighting' },
  LP: { key: 'LP', discipline: 'Landscape', description: 'Landscape Planting' },
  LR: {
    key: 'LR',
    discipline: 'Landscape',
    description: 'Landscape Relocation',
  },
  LS: { key: 'LS', discipline: 'Landscape', description: 'Landscape Site' },
  M: { key: 'M', discipline: 'Mechanical', description: 'Mechanical' },
  MD: {
    key: 'MD',
    discipline: 'Mechanical',
    description: 'Mechanical Demolition',
  },
  MH: { key: 'MH', discipline: 'Mechanical', description: 'Mechanical HVAC' },
  MI: {
    key: 'MI',
    discipline: 'Mechanical',
    description: 'Mechanical Instrumentation',
  },
  MP: { key: 'MP', discipline: 'Mechanical', description: 'Mechanical Piping' },
  MS: { key: 'MS', discipline: 'Mechanical', description: 'Mechanical Site' },
  P: { key: 'P', discipline: 'Plumbing', description: 'Plumbing' },
  PD: { key: 'PD', discipline: 'Plumbing', description: 'Plumbing Demolition' },
  PL: { key: 'PL', discipline: 'Plumbing', description: 'Plumbing' },
  PP: { key: 'PP', discipline: 'Plumbing', description: 'Plumbing Piping' },
  PQ: { key: 'PQ', discipline: 'Plumbing', description: 'Plumbing Equipment' },
  PS: { key: 'PS', discipline: 'Plumbing', description: 'Plumbing Site' },
  Q: { key: 'Q', discipline: 'Equipment', description: 'Equipment' },
  QA: { key: 'QA', discipline: 'Equipment', description: 'Equipment Athletic' },
  QB: { key: 'QB', discipline: 'Equipment', description: 'Equipment Bank' },
  QC: {
    key: 'QC',
    discipline: 'Equipment',
    description: 'Equipment Dry Cleaning',
  },
  QD: {
    key: 'QD',
    discipline: 'Equipment',
    description: 'Equipment Detention',
  },
  QE: {
    key: 'QE',
    discipline: 'Equipment',
    description: 'Equipment Educational',
  },
  QF: {
    key: 'QF',
    discipline: 'Equipment',
    description: 'Equipment Food Service',
  },
  QH: { key: 'QH', discipline: 'Equipment', description: 'Equipment Hospital' },
  QL: {
    key: 'QL',
    discipline: 'Equipment',
    description: 'Equipment Laboratory',
  },
  QM: {
    key: 'QM',
    discipline: 'Equipment',
    description: 'Equipment Maintenance',
  },
  QP: {
    key: 'QP',
    discipline: 'Equipment',
    description: 'Equipment Parking Lot',
  },
  QR: { key: 'QR', discipline: 'Equipment', description: 'Equipment Retail' },
  QS: { key: 'QS', discipline: 'Equipment', description: 'Equipment Site' },
  QT: {
    key: 'QT',
    discipline: 'Equipment',
    description: 'Equipment Theatrical',
  },
  QV: {
    key: 'QV',
    discipline: 'Equipment',
    description: 'Equipment Video/Photographic',
  },
  QY: { key: 'QY', discipline: 'Equipment', description: 'Equipment Security' },
  R: { key: 'R', discipline: 'Resource', description: 'Resource' },
  RA: {
    key: 'RA',
    discipline: 'Resource',
    description: 'Resource Architectural',
  },
  RC: { key: 'RC', discipline: 'Resource', description: 'Resource Civil' },
  RE: { key: 'RE', discipline: 'Resource', description: 'Resource Electrical' },
  RM: { key: 'RM', discipline: 'Resource', description: 'Resource Mechanical' },
  RR: {
    key: 'RR',
    discipline: 'Resource',
    description: 'Resource Real Estate',
  },
  RS: { key: 'RS', discipline: 'Resource', description: 'Resource Structural' },
  S: { key: 'S', discipline: 'Structural', description: 'Structural' },
  SB: {
    key: 'SB',
    discipline: 'Structural',
    description: 'Structural Substructure',
  },
  SD: {
    key: 'SD',
    discipline: 'Structural',
    description: 'Structural Demolition',
  },
  SF: {
    key: 'SF',
    discipline: 'Structural',
    description: 'Structural Framing',
  },
  SS: { key: 'SS', discipline: 'Structural', description: 'Structural Site' },
  T: {
    key: 'T',
    discipline: 'Telecommunications',
    description: 'Telecommunications',
  },
  TA: {
    key: 'TA',
    discipline: 'Telecommunications',
    description: 'Telecommunications Audio Visual',
  },
  TC: {
    key: 'TC',
    discipline: 'Telecommunications',
    description: 'Telecommunications Clock and Program',
  },
  TI: {
    key: 'TI',
    discipline: 'Telecommunications',
    description: 'Telecommunications Intercom',
  },
  TM: {
    key: 'TM',
    discipline: 'Telecommunications',
    description: 'Telecommunications Monitoring',
  },
  TN: {
    key: 'TN',
    discipline: 'Telecommunications',
    description: 'Telecommunications Data Networks',
  },
  TT: {
    key: 'TT',
    discipline: 'Telecommunications',
    description: 'Telecommunications Telephone',
  },
  TY: {
    key: 'TY',
    discipline: 'Telecommunications',
    description: 'Telecommunications Security',
  },
  V: { key: 'V', discipline: 'Survey/Mapping', description: 'Survey/Mapping' },
  VA: {
    key: 'VA',
    discipline: 'Survey/Mapping',
    description: 'Survey/Mapping Aerial',
  },
  VC: {
    key: 'VC',
    discipline: 'Survey/Mapping',
    description: 'Survey/Mapping Computated Points',
  },
  VF: {
    key: 'VF',
    discipline: 'Survey/Mapping',
    description: 'Survey/Mapping Field',
  },
  VI: {
    key: 'VI',
    discipline: 'Survey/Mapping',
    description: 'Survey/Mapping Digital',
  },
  VN: {
    key: 'VN',
    discipline: 'Survey/Mapping',
    description: 'Survey/Mapping Node Points',
  },
  VS: {
    key: 'VS',
    discipline: 'Survey/Mapping',
    description: 'Survey/Mapping Staked Points',
  },
  VU: {
    key: 'VU',
    discipline: 'Survey/Mapping',
    description: 'Survey/Mapping Combined Utilities',
  },
  W: {
    key: 'W',
    discipline: 'Distributed Energy',
    description: 'Distributed Energy',
  },
  WC: {
    key: 'WC',
    discipline: 'Distributed Energy',
    description: 'Distributed Energy Civil',
  },
  WD: {
    key: 'WD',
    discipline: 'Distributed Energy',
    description: 'Distributed Energy Demolition',
  },
  WI: {
    key: 'WI',
    discipline: 'Distributed Energy',
    description: 'Distributed Energy Interconnection',
  },
  WP: {
    key: 'WP',
    discipline: 'Distributed Energy',
    description: 'Distributed Energy Power',
  },
  WS: {
    key: 'WS',
    discipline: 'Distributed Energy',
    description: 'Distributed Energy Structural',
  },
  WT: {
    key: 'WT',
    discipline: 'Distributed Energy',
    description: 'Distributed Energy Telecommunications',
  },
  WY: {
    key: 'WY',
    discipline: 'Distributed Energy',
    description: 'Distributed Energy Auxiliary Systems',
  },
  Z: {
    key: 'Z',
    discipline: 'Contractor/Shop Drawings',
    description: 'Contractor/Shop Drawings',
  },
  X: {
    key: 'X',
    discipline: 'Other',
    description: 'Other',
  },
};

export const detailedDisciplineOptions = Object.values(disciplineByKey).map(
  ({ key, description }): SelectOption => ({
    label: description,
    value: key,
  })
);

export interface DisciplineOption {
  label: string;
  value: string;
}

export const disciplineOptions: DisciplineOption[] = [
  {
    label: 'Architectural',
    value: 'A',
  },
  {
    label: 'Civil',
    value: 'C',
  },
  {
    label: 'Contractor/Shop Drawings',
    value: 'Z',
  },
  {
    label: 'Distributed Energy',
    value: 'W',
  },
  {
    label: 'Electrical',
    value: 'E',
  },
  {
    label: 'Equipment',
    value: 'Q',
  },
  {
    label: 'Fire Protection',
    value: 'F',
  },
  {
    label: 'General',
    value: 'G',
  },
  {
    label: 'Geotechnical',
    value: 'B',
  },
  {
    label: 'Hazardous Materials',
    value: 'H',
  },
  {
    label: 'Interiors',
    value: 'I',
  },
  {
    label: 'Landscape',
    value: 'L',
  },
  {
    label: 'Mechanical',
    value: 'M',
  },
  {
    label: 'Plumbing',
    value: 'P',
  },
  {
    label: 'Process',
    value: 'D',
  },
  {
    label: 'Resource',
    value: 'R',
  },
  {
    label: 'Structural',
    value: 'S',
  },
  {
    label: 'Survey/Mapping',
    value: 'V',
  },
  {
    label: 'Telecommunications',
    value: 'T',
  },
  {
    label: 'Other',
    value: 'X',
  },
];

export type DisciplineOptionsByKey = {
  [key: string]: DisciplineOption;
};

export const getDisciplineByKey = (key: string): string => {
  if (!disciplineByKey[key]) {
    return '';
  }
  return disciplineByKey[key].discipline;
};
